<template>
  <div>
    {{ msg }}
    <div
      v-if="additionalMsg"
      color="primary"
    >
      {{ additionalMsg }}
    </div>
  </div>
</template>


<script>
export default {
    data() {
        return {
            msg: '',
            additionalMsg: '',
        };
    },
    created() {
        this.msg = this.$attrs.msg;
        this.additionalMsg = this.$attrs.additionalMsg;
    },
};
</script>

  <style>
  .modal {
    min-height: auto !important;
    height: auto !important;
  }
  </style>
